export const NAMESPACE = 'commands';
export const NAMESPACE_NATIVE_FRAMEWORKS = 'native-frameworks-test-cases';
export const NAMESPACE_JS_FRAMEWORKS = 'js-frameworks-test-cases';

export const NATIVE_FRAMEWORKS_SUCCESS_STATUS = 'SUCCESS';
export const NATIVE_FRAMEWORKS_FAILURE_STATUS = 'FAILURE';
export const RDC_NATIVE_FRAMEWORKS_TEST_STATUS_MAPPING = Object.freeze({
  [NATIVE_FRAMEWORKS_SUCCESS_STATUS]: 0,
  [NATIVE_FRAMEWORKS_FAILURE_STATUS]: 1,
});
